import { color } from '@material-ui/system'
import React, { Component } from 'react'
import Script from 'react-load-script'
import Cookies from 'js-cookie';
import { BASE_URLs } from '../Constants/BaseURL';
import LogoutLink from "./LogoutLink";

export default class PrivacyPolicy extends Component {


  constructor(props) {
    super(props)

    this.state = {

      // id : this.props.match.params.id, 
      foo: [],
      Menu: [],
      Details: [],
      newArray: [],
      ourstory: [],
      howitworks: [],
      beaparopakari: [],
      whatwedo: [],
      blog: [],
      login: [],
      indiaexpensless: [],
      oppertunitybringsmile: [],
      contactus: [],
      termsandcondition: [],
      causes: [],
      beneficiaries: [],
      paropakaris: [],
      amountraised: [],
      copyright: [],
      whatwedodesc: [],
      crowdfunding: [],
      humanelement: [],
      nofeecommision: [],
      nomiddlemen: [],
      privacypolicy: [],
      encourageaultruism: [], comingsoon: [],
      notify: [],
      invite: [], profile: [], changepassword: [], group: [], logout: [], myjourney: [],
      createacause: [],
      langID: [],
      movedown: true,
      copyright_new: [],
      paropakari_new: [],
    }
    this.DefaultMenu = this.DefaultMenu.bind(this);
    this.handleChanges = this.handleChanges.bind(this);
  }
  checkfun = (e) => {
    this.setState({
      movedown: !this.state.movedown
    })
  }

  Footer() {

    


  let url = `${BASE_URLs}Authenticate/Get_FooterDetails`;
    let data = this.state;

    
    
    fetch(url, {
      method: 'GET',
      headers: {
        "Content-type": "application/json",
        "Accept": "application/json",

        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
      //body:JSON.stringify(data)
    }).then(response => response.json())
      .then(data => {
        this.setState({
          foo: data
        });
        
        // 
      });
  }

  notify = () => {


    let url = "https://apitest.paropakari.com/api/GetProfile/Notification_Count";
    let data = this.state;
    let user = JSON.parse(localStorage.getItem('user'));
    const accessToken = user;
    
    
    fetch(url, {
      method: 'GET',
      headers: {
        "Content-type": "application/json",
        "Accept": "application/json",
        Authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
      //body:JSON.stringify(data)
    }).then(response => response.json())
      .then(data => {
        this.setState({
          notify: data
        });
        
        localStorage.setItem('noticount', JSON.stringify(data[0].noticount));
        // 
      });
  }

  DefaultMenu() {
    //  
    let RefreshID = 0;
    window.sessionStorage.setItem('reload', (RefreshID));
    let reloadsmyactivity = 0;
    window.sessionStorage.setItem('reloadsmyactivity', (reloadsmyactivity));
    window.sessionStorage.setItem('responsepagereload', (reloadsmyactivity));
    window.sessionStorage.setItem('notificationpagereload', (reloadsmyactivity));
    window.sessionStorage.setItem('Indexreload', (reloadsmyactivity));
    let langval = "English";
    
    localStorage.setItem('menuid', langval);
    let MID = "English";
    if (sessionStorage.getItem('translate') !== null) {
      MID = sessionStorage.getItem('translate');
    }
    else {
      MID = "English";
    }
    if (MID != null) {


      let url =
        "https://apitest.paropakari.com/api/Authenticate/Translatev?values=OurStory~HowItWorks~Blog~Login~BeaParopakari~WhatWeDo~We are Indias only expenseless direct crowdfunding and support platform that connects the needy with the more fortunate directly without third party involvement or fees~Opportunity to Bring a Smile~Contact Us~Terms and Conditions~Copyright © 2022 Paropakari&lang=" + MID;
      let user = JSON.parse(localStorage.getItem("user"));
      const accessToken = user;
      
      fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            Details: data
          });
          
          const longArray = data;
          const size = 1;
          var ary = data;
          localStorage.setItem('menuid', 'English');
          const newArrayyy = new Array(Math.ceil(longArray.length / size)).fill("")
            .map(function () { return this.splice(0, size) }, longArray.slice());
          var items = data;
          var Ourstory = typeof items[0] !== "undefined" ? items[0] : null;
          var Howitwork = typeof items[1] !== "undefined" ? items[1] : null;
          var Blog = typeof items[2] !== "undefined" ? items[2] : null;
          var Login = typeof items[3] !== "undefined" ? items[3] : null;
          var Contactus = typeof items[8] !== "undefined" ? items[8] : null;
          var Termsandcondition = typeof items[9] !== "undefined" ? items[9] : null;
          var CopyRight = typeof items[10] !== "undefined" ? items[10] : null;

          var Beaparopakari = typeof items[4] !== "undefined" ? items[4] : null;
          var OppertunitytoBSmile = typeof items[7] !== "undefined" ? items[7] : null;
          var Whatwedo = typeof items[5] !== "undefined" ? items[5] : null;

          var Whatwedodesc = typeof items[6] !== "undefined" ? items[6] : null;

          var LangID = MID;
          window.sessionStorage.setItem('translate', (LangID));
          this.setState({
            ourstory: Ourstory,
            howitworks: Howitwork,
            blog: Blog,
            login: Login,
            beaparopakari: Beaparopakari,
            contactus: Contactus,
            termsandcondition: Termsandcondition,
            copyright: CopyRight,
            whatwedo: Whatwedo,
            oppertunitybringsmile: OppertunitytoBSmile,
            whatwedodesc: Whatwedodesc,
            langID: LangID,


          });

        });

    }
    if (MID != null) {


      let url =
        "https://apitest.paropakari.com/api/Authenticate/Translatev?values=Causes~Beneficiaries~Paropakaris~Amount Raised~EncourageAltruism~Crowd funding with:~A Human Element~No Fees/Commission~No Middlemen~Coming Soon~Privacy Policy&lang=" + MID;
      let user = JSON.parse(localStorage.getItem("user"));
      const accessToken = user;
      
      fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            Details: data
          });
          
          const longArray = data;
          const size = 1;
          var ary = data;
          localStorage.setItem('menuid', 'English');
          const newArrayyy = new Array(Math.ceil(longArray.length / size)).fill("")
            .map(function () { return this.splice(0, size) }, longArray.slice());
          var items = data;

          var Causes = typeof items[0] !== "undefined" ? items[0] : null;
          var Beneficiaries = typeof items[1] !== "undefined" ? items[1] : null;
          var Paropakaris = typeof items[2] !== "undefined" ? items[2] : null;
          var Amountraised = typeof items[3] !== "undefined" ? items[3] : null;

          var Crowdfunding = typeof items[5] !== "undefined" ? items[5] : null;
          var HumanElement = typeof items[6] !== "undefined" ? items[6] : null;
          var NoFeeCommision = typeof items[7] !== "undefined" ? items[7] : null;
          var NoMiddlemen = typeof items[8] !== "undefined" ? items[8] : null;
          var CominSoon = typeof items[9] !== "undefined" ? items[9] : null;
          var PrivacyPolicy = typeof items[10] !== "undefined" ? items[10] : null;
          var EncourageAltruism = typeof items[4] !== "undefined" ? items[4] : null;


          var LangID = MID;
          window.sessionStorage.setItem('translate', (LangID));
          this.setState({

            causes: Causes,
            beneficiaries: Beneficiaries,
            paropakaris: Paropakaris,
            amountraised: Amountraised,
            crowdfunding: Crowdfunding,
            humanelement: HumanElement,
            nofeecommision: NoFeeCommision,
            nomiddlemen: NoMiddlemen,
            privacypolicy: PrivacyPolicy,
            langID: LangID,
            comingsoon: CominSoon,

          });


        });

    }
    if (MID != null) {
      let url =
        "https://apitest.paropakari.com/api/Authenticate/Translatev?values=Invite~Profile~Change Password~Group~Logout~My Journey~Create a Cause&lang=" + MID;
      let user = JSON.parse(localStorage.getItem("user"));
      const accessToken = user;
      
      fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            Details: data
          });
          
          const longArray = data;
          const size = 1;
          var ary = data;
          localStorage.setItem('menuid', 'English');
          const newArrayyy = new Array(Math.ceil(longArray.length / size)).fill("")
            .map(function () { return this.splice(0, size) }, longArray.slice());
          var items = data;

          var Invite = typeof items[0] !== "undefined" ? items[0] : null;
          var Profile = typeof items[1] !== "undefined" ? items[1] : null;
          var ChangePasssword = typeof items[2] !== "undefined" ? items[2] : null;
          var Group = typeof items[3] !== "undefined" ? items[3] : null;
          var Logout = typeof items[4] !== "undefined" ? items[4] : null;
          var Myjourney = typeof items[5] !== "undefined" ? items[5] : null;
          var Createacause = typeof items[6] !== "undefined" ? items[6] : null;

          var LangID = MID;
          window.sessionStorage.setItem('translate', (LangID));
          this.setState({


            invite: Invite,
            profile: Profile,
            changepassword: ChangePasssword,
            group: Group,
            logout: Logout,
            myjourney: Myjourney,
            createacause: Createacause,
            langID: LangID

          });

        });
    }
    if (MID != null) {
      let url =
        "https://apitest.paropakari.com/api/Authenticate/Translatev?values=Copyright~Paropakari&lang=" + MID;
      let user = JSON.parse(localStorage.getItem("user"));
      const accessToken = user;
      
      fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            Details: data
          });
          const longArray = data;
          const size = 1;
          var ary = data;
          // localStorage.setItem('menuid', 'English');
          const newArrayyy = new Array(Math.ceil(longArray.length / size)).fill("")
            .map(function () { return this.splice(0, size) }, longArray.slice());
          var items = data;
          var copyright_new = typeof items[0] !== "undefined" ? items[0] : null;
          var paropakari_new = typeof items[1] !== "undefined" ? items[1] : null;
        
          var LangID = MID;
          window.sessionStorage.setItem('translate', (LangID));
          localStorage.setItem('MenuID', JSON.stringify(LangID));
          this.setState({
            copyright_new: copyright_new,
            paropakari_new: paropakari_new,            
          });
        });
    }
  }



  handleChanges(event) {
    this.setState({ value: event.target.value });
    
    localStorage.setItem('menuid', event.target.value);
    // let l_id = JSON.parse(localStorage.getItem('menuid'));
    
    let values = ['OurStory', 'HowItWorks', 'Blog', 'Login', 'BeaParopakari', 'What We Do'];
    
    let MID = event.target.value;
    if (MID != null) {

      let url =
        "https://apitest.paropakari.com/api/Authenticate/Translatev?values=OurStory~HowItWorks~Blog~Login~BeaParopakari~WhatWeDo~We are Indias only expenseless direct crowdfunding and support platform that connects the needy with the more fortunate directly without third party involvement or fees~Opportunity to Bring a Smile~Contact Us~Terms and Conditions~Copyright © 2022 Paropakari&lang=" + MID;
      let user = JSON.parse(localStorage.getItem("user"));
      const accessToken = user;
      
      fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            Details: data
          });
          
          const longArray = data;
          const size = 1;
          var ary = data;
          localStorage.setItem('menuid', 'English');
          const newArrayyy = new Array(Math.ceil(longArray.length / size)).fill("")
            .map(function () { return this.splice(0, size) }, longArray.slice());
          var items = data;
          var Ourstory = typeof items[0] !== "undefined" ? items[0] : null;
          var Howitwork = typeof items[1] !== "undefined" ? items[1] : null;
          var Blog = typeof items[2] !== "undefined" ? items[2] : null;
          var Login = typeof items[3] !== "undefined" ? items[3] : null;
          var Contactus = typeof items[8] !== "undefined" ? items[8] : null;
          var Termsandcondition = typeof items[9] !== "undefined" ? items[9] : null;
          var CopyRight = typeof items[10] !== "undefined" ? items[10] : null;

          var Beaparopakari = typeof items[4] !== "undefined" ? items[4] : null;
          var OppertunitytoBSmile = typeof items[7] !== "undefined" ? items[7] : null;
          var Whatwedo = typeof items[5] !== "undefined" ? items[5] : null;

          var Whatwedodesc = typeof items[6] !== "undefined" ? items[6] : null;

          var LangID = MID;
          window.sessionStorage.setItem('translate', (LangID));
          this.setState({
            ourstory: Ourstory,
            howitworks: Howitwork,
            blog: Blog,
            login: Login,
            beaparopakari: Beaparopakari,
            contactus: Contactus,
            termsandcondition: Termsandcondition,
            copyright: CopyRight,
            whatwedo: Whatwedo,
            oppertunitybringsmile: OppertunitytoBSmile,
            whatwedodesc: Whatwedodesc,
            langID: LangID,


          });

          // alert(firstItem);
          const trans = "Vijayaasri";
          let l_name = this.state.newArray[0];
          let l_names = l_name;

          
          
          const n = 2;
          const firstNElements = longArray.slice(0, n).map(({ result }) => {
            return (<p >{result}</p>)
          });
          // 
        });

    }
    if (MID != null) {


      let url =
        "https://apitest.paropakari.com/api/Authenticate/Translatev?values=Causes~Beneficiaries~Paropakaris~Amount Raised~EncourageAltruism~Crowd funding with:~A Human Element~No Fees/Commission~No Middlemen~Coming Soon~Privacy Policy&lang=" + MID;
      let user = JSON.parse(localStorage.getItem("user"));
      const accessToken = user;
      
      fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            Details: data
          });
          
          const longArray = data;
          const size = 1;
          var ary = data;
          localStorage.setItem('menuid', 'English');
          const newArrayyy = new Array(Math.ceil(longArray.length / size)).fill("")
            .map(function () { return this.splice(0, size) }, longArray.slice());
          var items = data;

          var Causes = typeof items[0] !== "undefined" ? items[0] : null;
          var Beneficiaries = typeof items[1] !== "undefined" ? items[1] : null;
          var Paropakaris = typeof items[2] !== "undefined" ? items[2] : null;
          var Amountraised = typeof items[3] !== "undefined" ? items[3] : null;

          var Crowdfunding = typeof items[5] !== "undefined" ? items[5] : null;
          var HumanElement = typeof items[6] !== "undefined" ? items[6] : null;
          var NoFeeCommision = typeof items[7] !== "undefined" ? items[7] : null;
          var NoMiddlemen = typeof items[8] !== "undefined" ? items[8] : null;
          var CominSoon = typeof items[9] !== "undefined" ? items[9] : null;
          var PrivacyPolicy = typeof items[10] !== "undefined" ? items[10] : null;
          var EncourageAltruism = typeof items[4] !== "undefined" ? items[4] : null;


          var LangID = MID;
          window.sessionStorage.setItem('translate', (LangID));
          this.setState({

            causes: Causes,
            beneficiaries: Beneficiaries,
            paropakaris: Paropakaris,
            amountraised: Amountraised,
            crowdfunding: Crowdfunding,
            humanelement: HumanElement,
            nofeecommision: NoFeeCommision,
            nomiddlemen: NoMiddlemen,
            privacypolicy: PrivacyPolicy,
            langID: LangID,
            comingsoon: CominSoon,

          });

        });

    }
    if (MID != null) {
      let url =
        "https://apitest.paropakari.com/api/Authenticate/Translatev?values=Invite~Profile~Change Password~Group~Logout~My Journey~Create a Cause&lang=" + MID;
      let user = JSON.parse(localStorage.getItem("user"));
      const accessToken = user;
      
      fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            Details: data
          });
          
          const longArray = data;
          const size = 1;
          var ary = data;
          localStorage.setItem('menuid', 'English');
          const newArrayyy = new Array(Math.ceil(longArray.length / size)).fill("")
            .map(function () { return this.splice(0, size) }, longArray.slice());
          var items = data;

          var Invite = typeof items[0] !== "undefined" ? items[0] : null;
          var Profile = typeof items[1] !== "undefined" ? items[1] : null;
          var ChangePasssword = typeof items[2] !== "undefined" ? items[2] : null;
          var Group = typeof items[3] !== "undefined" ? items[3] : null;
          var Logout = typeof items[4] !== "undefined" ? items[4] : null;
          var Myjourney = typeof items[5] !== "undefined" ? items[5] : null;
          var Createacause = typeof items[6] !== "undefined" ? items[6] : null;

          var LangID = MID;
          window.sessionStorage.setItem('translate', (LangID));
          this.setState({


            invite: Invite,
            profile: Profile,
            changepassword: ChangePasssword,
            group: Group,
            logout: Logout,
            myjourney: Myjourney,
            createacause: Createacause,
            langID: LangID

          });

        });
    }
    if (MID != null) {


      let url =
        "https://apitest.paropakari.com/api/Authenticate/Translatev?values=Cancel&lang=" + MID;
      let user = JSON.parse(localStorage.getItem("user"));
      const accessToken = user;
      
      fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            Details: data
          });
          
          const longArray = data;
          const size = 1;
          var ary = data;
          // localStorage.setItem('menuid', 'English');
          const newArrayyy = new Array(Math.ceil(longArray.length / size)).fill("")
            .map(function () { return this.splice(0, size) }, longArray.slice());
          var items = data;


          var Cancel = typeof items[0] !== "undefined" ? items[0] : null;


          var LangID = MID;
          let GGIDS = MID;

          let datatranslirate = GGIDS;


          



          //localStorage.setItem("GoogleTranslate123",InviteFriendsDropdown)

          let datatransIDs = MID;

          if (datatranslirate == "English") {
            datatransIDs = "/en/en";

          }
          else

            if (datatranslirate == "Kannada") {
              datatransIDs = "/en/kn";
            }

            else
              if (datatranslirate == "Tamil") {
                datatransIDs = "/en/ta";
              }
              else
                if (datatranslirate == "Telugu") {
                  datatransIDs = "/en/te";
                }
                else
                  if (datatranslirate == "Hindi") {
                    datatransIDs = "/en/hi";
                  }
                  else
                  if (datatranslirate == "Spanish") {
                    datatransIDs = "/en/es";
                  }
                  else
                    if (datatranslirate == MID) {
                      datatransIDs = MID;
                    }
          let RefreshID = 0;
          window.sessionStorage.setItem('reload', (RefreshID));
          let reloadsmyactivity = 0;
          window.sessionStorage.setItem('reloadsmyactivity', (reloadsmyactivity));
          window.sessionStorage.setItem('responsepagereload', (reloadsmyactivity));
          window.sessionStorage.setItem('notificationpagereload', (reloadsmyactivity));
          window.sessionStorage.setItem('Indexreload', (reloadsmyactivity));
          window.sessionStorage.setItem('GoogleTranslateValues', (datatransIDs));

          
          let googletrasvalues = localStorage.setItem("GoogleTranslateValues", datatransIDs);

          


          

          Cookies.remove('googtrans', { domain: '.paropakari.com' });
          Cookies.remove('googtrans', { domain: 'https://paropakari.com/' });

          Cookies.remove('googtrans', { domain: 'https://www.paropakari.com/' });
          let usernames = localStorage.getItem("GoogleTranslateValues", datatransIDs);
          let values = datatransIDs;
          
          

          function setCookie(cName, cValue, expDays) {
            let date = new Date();
            date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
            const expires = "expires=" + date.toUTCString();
            document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
            // window.location.reload();
          }

          Cookies.set('googtrans', datatransIDs, { domain: 'https://test.paropakari.com/#/' });
          Cookies.set('googtrans', datatransIDs, { domain: '.paropakari.com' });
          Cookies.set('googtrans', datatransIDs, { domain: 'https://www.paropakari.com/' });
          Cookies.set('googtrans', datatransIDs, { domain: 'https://paropakari.com/' });
          setCookie('googtrans', datatransIDs, 30);
          setCookie('googtrans', datatransIDs, 'https://test.paropakari.com/#/');
          setCookie('googtrans', datatransIDs, '.paropakari.com');
          setCookie('googtrans', datatransIDs, 'https://www.paropakari.com/');
          setCookie('googtrans', datatransIDs, 'https://paropakari.com/');
          let cookie = Cookies.get('googtrans', 'https://test.paropakari.com/#/');
          
          window.sessionStorage.setItem('translate', (LangID));
          localStorage.setItem('MenuID', JSON.stringify(LangID));

          this.setState({
            cancel: Cancel,


          });


        });
    }
    if (MID != null) {
      let url =
        "https://apitest.paropakari.com/api/Authenticate/Translatev?values=Copyright~Paropakari&lang=" + MID;
      let user = JSON.parse(localStorage.getItem("user"));
      const accessToken = user;
      
      fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            Details: data
          });
          const longArray = data;
          const size = 1;
          var ary = data;
          // localStorage.setItem('menuid', 'English');
          const newArrayyy = new Array(Math.ceil(longArray.length / size)).fill("")
            .map(function () { return this.splice(0, size) }, longArray.slice());
          var items = data;
          var copyright_new = typeof items[0] !== "undefined" ? items[0] : null;
          var paropakari_new = typeof items[1] !== "undefined" ? items[1] : null;
        
          var LangID = MID;
          window.sessionStorage.setItem('translate', (LangID));
          localStorage.setItem('MenuID', JSON.stringify(LangID));
          this.setState({
            copyright_new: copyright_new,
            paropakari_new: paropakari_new,            
          });
        });
    }
  }
  renderIcon() {
    const longArray = [1, 2, 3];
    const size = 1;

    const newArray = new Array(Math.ceil(longArray.length / size)).fill("")
      .map(function () { return this.splice(0, size) }, longArray.slice());

    
    return (
      <div>{newArray}</div>
    )
  }

  componentDidMount() {

   
    window.addEventListener('load', this.DefaultMenu);
    this.DefaultMenu();
    let user = JSON.parse(localStorage.getItem('username'));
    if (user != null) {
      window.addEventListener('load', this.Footer);
      this.Footer();
      window.addEventListener('load', this.notify);
      this.notify();
    }
   
    const element = document.querySelector('.VIpgJd-ZVi9od-ORHb-OEVmcd');
    if (element && window.getComputedStyle(element).getPropertyValue('position') === 'fixed') {
      element.style.position = 'absolute';
    }
    document.title = "India's only expenseless, direct crowdfunding platform"
  }

  componentWillUnmount() {

  
    window.removeEventListener('load', this.DefaultMenu);
    this.DefaultMenu();
    let user = JSON.parse(localStorage.getItem('username'));
    if (user != null) {
      window.addEventListener('load', this.Footer);
      this.Footer();
      window.addEventListener('load', this.notify);
      this.notify();
    }
  }
  handleScriptCreate() {
    this.setState({ scriptLoaded: false })
  }

  handleScriptError() {
    this.setState({ scriptError: true })
  }

  handleScriptLoad() {
    this.setState({ scriptLoaded: true })
  }
  render() {
    //   const {emps} = this.state;
    if (localStorage.username != null) {
      var username = JSON.parse(localStorage.username);
    }
    let { foo, Menu } = this.state;
    const { notify } = this.state;
    const currentYear = new Date().getFullYear();
    var noticount = JSON.parse(localStorage.getItem('noticount'));
    const { newArray, howitworks, beaparopakari, whatwedo, blog, login, indiaexpensless, ourstory, privacypolicy,
      invite, profile, changepassword, group, logout, myjourney, createacause,
      oppertunitybringsmile, contactus, termsandcondition, causes, beneficiaries, paropakaris, amountraised, 
      copyright, whatwedodesc, encourageaultruism, crowdfunding, humanelement, nofeecommision, nomiddlemen, 
      langID, weareindias, comingsoon,copyright_new, paropakari_new } = this.state;
    if (localStorage.username != null) {
      var username = JSON.parse(localStorage.username);
    }
    return (
      <div className="VIpgJd-ZVi9od-ORHb-OEVmcd" style={{ position: "absolute" }}>
        <div style={{ backgroundImage: "url(" + "./assets/images/10.jpg" + ")" }} className="notranslate">
          {/* <meta http-equiv="refresh" content="10"/>   */}
          <link href="./assets/css/bootstrap.min.css" rel="stylesheet" />
          <link href="./assets/css/font-awesome.min.css" rel="stylesheet" />
          <link href="./assets/css/lightbox.css" rel="stylesheet" />
          <link href="./assets/css/animate.min.css" rel="stylesheet" />
          <link href="./assets/css/main.css" rel="stylesheet" />

          {/*[if lt IE 9]>
              
              
          <![endif]*/}
          <link rel="shortcut icon" href="images/ico/favicon.ico" />
          <link rel="apple-touch-icon-precomposed" sizes="144x144" href="images/ico/apple-touch-icon-144-precomposed.png" />
          <link rel="apple-touch-icon-precomposed" sizes="114x114" href="images/ico/apple-touch-icon-114-precomposed.png" />
          <link rel="apple-touch-icon-precomposed" sizes="72x72" href="images/ico/apple-touch-icon-72-precomposed.png" />
          <link rel="apple-touch-icon-precomposed" href="images/ico/apple-touch-icon-57-precomposed.png" />


          <link rel="shortcut icon" href="images/ico/favicon.ico" />
          <link rel="apple-touch-icon-precomposed" sizes="144x144" href="images/ico/apple-touch-icon-144-precomposed.png" />
          <link rel="apple-touch-icon-precomposed" sizes="114x114" href="images/ico/apple-touch-icon-114-precomposed.png" />
          <link rel="apple-touch-icon-precomposed" sizes="72x72" href="images/ico/apple-touch-icon-72-precomposed.png" />
          <link rel="apple-touch-icon-precomposed" href="images/ico/apple-touch-icon-57-precomposed.png" />

          <select className="form-control" style={{ display: 'inline', width: '10%', marginTop: '0', marginLeft: '0', float: 'right', width: 'fit-content' }} value={this.state.value} onChange={this.handleChanges}>
            <option value="English">Languages</option>
            <option value="Kannada">Kannada</option>
            <option value="Tamil">Tamil</option>
            <option value="Hindi">Hindi</option>
            <option value="Telugu">Telugu</option>
             <option value="Spanish">Spanish</option>
            <option value="English">English</option>
          </select>
          &nbsp;&nbsp; &nbsp;&nbsp;


          <div>
          <div className="mag notranslate">
                    <div class="pro-nav">
                      <input type="checkbox" id="pro-nav-check" onClick={this.checkfun} />
                      <div class="pro-nav-header">
                        <div class="pro-nav-title notranslate">
                          <a className="navbar-brand" href="#/Index1">
                            <h1 className="navbar-new-text"><img src="./assets/images/plogo.png" alt="logo" style={{ marginBottom: '17px', width: '26%', fontsize: '300px' }} />AROPAKARI
                            </h1>
                          </a>
                        </div>
                      </div>

                      <div class="pro-nav-btn">
                        <label for="pro-nav-check">
                          <div className="pro-naav">
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>
                        </label>
                      </div>

                      {langID == "English" ? <>
                        <div class="pro-nav-links pro-side">
                          <p class='pro-center'>
                            <a className="new-design" href="#/Login">{beaparopakari.result}</a>
                          </p>
                          <div className="parop-boxx parop-boxx-top">
                            <a href="#/Ourstory" className="parop-menu">{ourstory.result}</a>
                            <a href="#/Howitworks" className="parop-menu">{howitworks.result}</a>
                            <a href="#/Blog" className="parop-menu">{blog.result}</a>
                            <a href="#/Login" className="parop-menu">{login.result}</a>
                          </div>
                        </div>
                      </> : langID == "Spanish" ? <>
                        <div class="pro-nav-links pro-side">
                          <p class='pro-center'>
                            <a className="new-hindi-design" href="#/Login">{beaparopakari.result}</a>
                          </p>
                          <div className="parop-boxx parop-boxx-top">
                            <a href="#/Ourstory" className="parop-hindi-menu">{ourstory.result}</a>
                            <a href="#/Howitworks" className="parop-hindi-menu">{howitworks.result}</a>
                            <a href="#/Blog" className="parop-hindi-menu">{blog.result}</a>
                            <a href="#/Login" className="parop-hindi-menu">{login.result}</a>
                          </div>
                        </div>
                        </> : langID == "Telugu" ? <>
                        <div class="pro-nav-links pro-side">
                          <p class='pro-center'>
                            <a className="new-hindi-design" href="#/Login">{beaparopakari.result}</a>
                          </p>
                          <div className="parop-boxx parop-boxx-top">
                            <a href="#/Ourstory" className="parop-hindi-menu">{ourstory.result}</a>
                            <a href="#/Howitworks" className="parop-hindi-menu">{howitworks.result}</a>
                            <a href="#/Blog" className="parop-hindi-menu">{blog.result}</a>
                            <a href="#/Login" className="parop-hindi-menu">{login.result}</a>
                          </div>
                        </div>
                        </> : langID == "Hindi" ? <>
                        <div class="pro-nav-links pro-side">
                          <p class='pro-center'>
                            <a className="new-hindi-design" href="#/Login">{beaparopakari.result}</a>
                          </p>
                          <div className="parop-boxx parop-boxx-top">
                            <a href="#/Ourstory" className="parop-hindi-menu">{ourstory.result}</a>
                            <a href="#/Howitworks" className="parop-hindi-menu">{howitworks.result}</a>
                            <a href="#/Blog" className="parop-hindi-menu">{blog.result}</a>
                            <a href="#/Login" className="parop-hindi-menu">{login.result}</a>
                          </div>
                        </div>
                      </> : langID == "Kannada" ? <>
                        <div class="pro-nav-links pro-side">
                          <p class='pro-center'>
                            <a className="new-kannada-design" href="#/Login">{beaparopakari.result}</a>
                          </p>
                          <div className="parop-kannada-boxx parop-boxx-top">
                            <a href="#/Ourstory" className="parop-kannada-menu">{ourstory.result}</a>
                            <a href="#/Howitworks" className="parop-kannada-menu">{howitworks.result}</a>
                            <a href="#/Blog" className="parop-kannada-menu">{blog.result}</a>
                            <a href="#/Login" className="parop-kannada-menu">{login.result}</a>
                          </div>
                        </div>
                      </> : langID == "Tamil" ? <>
                        <div class="pro-nav-links pro-side">
                          <p class='pro-center'>
                            <a className="new-tamil-design" href="#/Login">{beaparopakari.result}</a>
                          </p>
                          <div className="parop-tamil-boxx parop-boxx-top">
                            <a href="#/Ourstory" className="parop-tamil-menu">{ourstory.result}</a>
                            <a href="#/Howitworks" className="parop-tamil-menu">{howitworks.result}</a>
                            <a href="#/Blog" className="parop-tamil-menu">{blog.result}</a>
                            <a href="#/Login" className="parop-tamil-menu">{login.result}</a>
                          </div>
                        </div>
                      </> : <>
                        <div class="pro-nav-links pro-side">
                          <p class='pro-center'>
                            <a className="new-telugu-design" href="#/Login">{beaparopakari.result}</a>
                          </p>
                          <div className="parop-boxx parop-boxx-top">
                            <a href="#/Ourstory" className="parop-telugu-menu">{ourstory.result}</a>
                            <a href="#/Howitworks" className="parop-telugu-menu">{howitworks.result}</a>
                            <a href="#/Blog" className="parop-telugu-menu">{blog.result}</a>
                            <a href="#/Login" className="parop-telugu-menu">{login.result}</a>
                          </div>
                        </div>
                      </>}
                    </div>
                  </div>

            {/* {(() => {if(username != null) {return (
  <div className="mag notranslate">
  <div class="pro-home-nav">
    <input type="checkbox" id="pro-home-nav-check" onClick={this.checkfun} />
    <div class="pro-home-nav-header">
      <div class="pro-home-nav-title notranslate">
        <a className="navbar-brand" href="#/HomePage">
          <h1 className="navbar-new-text"><img src="./assets/images/plogo.png" alt="logo" style={{ marginBottom: '17px', width: '26%', fontsize: '300px' }} />AROPAKARI
          </h1>
        </a>
      </div>
    </div>

    <div class="pro-home-nav-btn">
      <label for="pro-home-nav-check">
        <div className="pro-naav">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </label>
    </div>

    {langID == "English" ? <>
      <div class="pro-home-nav-links pro-side pro-top">
        <p class='pro-center'>
          <a className="new-design" href="#/CauseFor">{beaparopakari.result}</a>
        </p>
        <ul className="parop-home-boxx parop-boxx-top">
          <li className="parop-menu"><a href="#/Myactivity">{myjourney.result}</a></li>
          <li className="parop-menu"><a href="#/CauseFor">{createacause.result}</a></li>
          <li className="parop-menu"><a href="#/InviteFriend">{invite.result}</a></li>
          <li className="parop-menu parop-notify"><a href="#/Notification"><div class="fa fa-bell" style={{ fontsize: '24px' }}>{notify.map((notifyy) => (
            <span class="-count">


              {notifyy.noticount}

            </span>))}</div></a></li>
          <li className="parop-menu"><a><b>{username}</b> <i className="fa fa-angle-down"></i></a>
            <ul class="dropdown">
              <li className="hower-text"><a href="#/Profile"><b>{profile.result}</b></a></li>
              <li className="hower-text"><a href="#/ChangePassword"><b>{changepassword.result}</b></a></li>
              <li className="hower-text"><a href="#/Group"><b>{group.result}</b></a></li>
              <li className="hower-text"><a href="#/Login"><b>{logout.result}</b></a></li>
            </ul>
          </li>

        </ul>
      </div>
    </> : langID == "Hindi" ? <>
      <div class="pro-home-nav-links pro-side pro-top">
        <p class='pro-center'>
          <a className="new-design" href="#/CauseFor">{beaparopakari.result}</a>
        </p>
        <ul className="parop-home-boxx parop-boxx-top">
          <li className="parop-menu"><a href="#/Myactivity">{myjourney.result}</a></li>
          <li className="parop-menu"><a href="#/CauseFor">{createacause.result}</a></li>
          <li className="parop-menu"><a href="#/InviteFriend">{invite.result}</a></li>
          <li className="parop-menu parop-notify"><a href="#/Notification"><div class="fa fa-bell" style={{ fontsize: '24px' }}>{notify.map((notifyy) => (
            <span class="-count">


              {notifyy.noticount}

            </span>))}</div></a></li>
          <li className="parop-menu"><a><b>{username}</b> <i className="fa fa-angle-down"></i></a>
            <ul class="dropdown">
              <li className="hower-text"><a href="#/Profile"><b>{profile.result}</b></a></li>
              <li className="hower-text"><a href="#/ChangePassword"><b>{changepassword.result}</b></a></li>
              <li className="hower-text"><a href="#/Group"><b>{group.result}</b></a></li>
              <li className="hower-text"><a href="#/Login"><b>{logout.result}</b></a></li>
            </ul>
          </li>

        </ul>
      </div>
    </> : langID == "Tamil" ? <>
      <div class="pro-home-nav-links pro-side pro-top">
        <p class='pro-center'>
          <a className="new-tamil-design" href="#/CauseFor">{beaparopakari.result}</a>
        </p>
        <ul className="parop-home-tamil-boxx parop-boxx-top">
          <li className="parop-menu"><a href="#/Myactivity">{myjourney.result}</a></li>
          <li className="parop-menu"><a href="#/CauseFor">{createacause.result}</a></li>
          <li className="parop-menu"><a href="#/InviteFriend">{invite.result}</a></li>
          <li className="parop-menu parop-notify"><a href="#/Notification"><div class="fa fa-bell" style={{ fontsize: '24px' }}>{notify.map((notifyy) => (
            <span class="-count">


              {notifyy.noticount}

            </span>))}</div></a></li>
          <li className="parop-menu"><a><b>{username}</b> <i className="fa fa-angle-down"></i></a>
            <ul class="dropdown">
              <li className="hower-text"><a href="#/Profile"><b>{profile.result}</b></a></li>
              <li className="hower-text"><a href="#/ChangePassword"><b>{changepassword.result}</b></a></li>
              <li className="hower-text"><a href="#/Group"><b>{group.result}</b></a></li>
              <li className="hower-text"><a href="#/Login"><b>{logout.result}</b></a></li>
            </ul>
          </li>

        </ul>
      </div>
    </> : langID == "Kannada" ? <>
      <div class="pro-home-nav-links pro-side pro-top">
        <p class='pro-center'>
          <a className="new-telugu-design" href="#/CauseFor">{beaparopakari.result}</a>
        </p>
        <ul className="parop-home-tamil-boxx parop-boxx-top">
          <li className="parop-menu"><a href="#/Myactivity">{myjourney.result}</a></li>
          <li className="parop-menu"><a href="#/CauseFor">{createacause.result}</a></li>
          <li className="parop-menu"><a href="#/InviteFriend">{invite.result}</a></li>
          <li className="parop-menu parop-notify"><a href="#/Notification"><div class="fa fa-bell" style={{ fontsize: '24px' }}>{notify.map((notifyy) => (
            <span class="-count">


              {notifyy.noticount}

            </span>))}</div></a></li>
          <li className="parop-menu"><a><b>{username}</b> <i className="fa fa-angle-down"></i></a>
            <ul class="dropdown">
              <li className="hower-text"><a href="#/Profile"><b>{profile.result}</b></a></li>
              <li className="hower-text"><a href="#/ChangePassword"><b>{changepassword.result}</b></a></li>
              <li className="hower-text"><a href="#/Group"><b>{group.result}</b></a></li>
              <li className="hower-text"><a href="#/Login"><b>{logout.result}</b></a></li>
            </ul>
          </li>

        </ul>
      </div>
    </> : langID == "Telugu" ? <>
      <div class="pro-home-nav-links pro-side pro-top">
        <p class='pro-center'>
          <a className="new-telugu-design" href="#/CauseFor">{beaparopakari.result}</a>
        </p>
        <ul className="parop-home-tamil-boxx parop-boxx-top">
          <li className="parop-menu"><a href="#/Myactivity">{myjourney.result}</a></li>
          <li className="parop-menu"><a href="#/CauseFor">{createacause.result}</a></li>
          <li className="parop-menu"><a href="#/InviteFriend">{invite.result}</a></li>
          <li className="parop-menu parop-notify"><a href="#/Notification"><div class="fa fa-bell" style={{ fontsize: '24px' }}>{notify.map((notifyy) => (
            <span class="-count">


              {notifyy.noticount}

            </span>))}</div></a></li>
          <li className="parop-menu"><a><b>{username}</b> <i className="fa fa-angle-down"></i></a>
            <ul class="dropdown">
              <li className="hower-text"><a href="#/Profile"><b>{profile.result}</b></a></li>
              <li className="hower-text"><a href="#/ChangePassword"><b>{changepassword.result}</b></a></li>
              <li className="hower-text"><a href="#/Group"><b>{group.result}</b></a></li>
              <li className="hower-text"><a href="#/Login"><b>{logout.result}</b></a></li>
            </ul>
          </li>
        </ul>
      </div>
    </> : null}
  </div>
</div>

);
}
  else {return(

    <div className="mag notranslate">
    <div class="pro-nav">
<input type="checkbox" id="pro-nav-check" onClick={this.checkfun}/>
<div class="pro-nav-header">
<div class="pro-nav-title notranslate">
<a className="navbar-brand" href="#/Index1">
              <h1 className="navbar-new-text"><img src="./assets/images/plogo.png" alt="logo" style={{ marginBottom: '17px', width: '26%', fontsize: '300px' }} />AROPAKARI
              </h1>
            </a>
</div>
</div>

<div class="pro-nav-btn">
<label for="pro-nav-check">
<div className="pro-naav">
<span></span>
<span></span>
<span></span>
</div>
</label>
</div>

{langID == "English" ? <>
<div class="pro-nav-links pro-side">
   <p class='pro-center'>
<a className="new-design" href="#/Login">{beaparopakari.result}</a>
</p>
<div className="parop-boxx parop-boxx-top">
<a href="#/Ourstory" className="parop-menu">{ourstory.result}</a>
<a href="#/Howitworks" className="parop-menu">{howitworks.result}</a>
<a href="#/Blog" className="parop-menu">{blog.result}</a>
<a href="#/Login" className="parop-menu">{login.result}</a>
</div>
</div>
</> : langID == "Hindi" ? <>
<div class="pro-nav-links pro-side">
   <p class='pro-center'>
<a className="new-hindi-design" href="#/Login">{beaparopakari.result}</a>
</p>
<div className="parop-boxx parop-boxx-top">
<a href="#/Ourstory" className="parop-hindi-menu">{ourstory.result}</a>
<a href="#/Howitworks" className="parop-hindi-menu">{howitworks.result}</a>
<a href="#/Blog" className="parop-hindi-menu">{blog.result}</a>
<a href="#/Login" className="parop-hindi-menu">{login.result}</a>
</div>
</div>
</> : langID == "Kannada" ? <>
<div class="pro-nav-links pro-side">
   <p class='pro-center'>
<a className="new-kannada-design" href="#/Login">{beaparopakari.result}</a>
</p>
<div className="parop-kannada-boxx parop-boxx-top">
<a href="#/Ourstory" className="parop-kannada-menu">{ourstory.result}</a>
<a href="#/Howitworks" className="parop-kannada-menu">{howitworks.result}</a>
<a href="#/Blog" className="parop-kannada-menu">{blog.result}</a>
<a href="#/Login" className="parop-kannada-menu">{login.result}</a>
</div>
</div>
</> : langID == "Tamil" ? <>
<div class="pro-nav-links pro-side">
   <p class='pro-center'>
<a className="new-tamil-design" href="#/Login">{beaparopakari.result}</a>
</p>
<div className="parop-tamil-boxx parop-boxx-top">
<a href="#/Ourstory" className="parop-tamil-menu">{ourstory.result}</a>
<a href="#/Howitworks" className="parop-tamil-menu">{howitworks.result}</a>
<a href="#/Blog" className="parop-tamil-menu">{blog.result}</a>
<a href="#/Login" className="parop-tamil-menu">{login.result}</a>
</div>
</div>
</> : <>
<div class="pro-nav-links pro-side">
   <p class='pro-center'>
<a className="new-telugu-design" href="#/Login">{beaparopakari.result}</a>
</p>
<div className="parop-boxx parop-boxx-top">
<a href="#/Ourstory" className="parop-telugu-menu">{ourstory.result}</a>
<a href="#/Howitworks" className="parop-telugu-menu">{howitworks.result}</a>
<a href="#/Blog" className="parop-telugu-menu">{blog.result}</a>
<a href="#/Login" className="parop-telugu-menu">{login.result}</a>
</div>
</div>
</> }
</div>
</div>



   
 );}
})()} */}

            {/* <header id="header" style={{backgroundImage: "url(" + "./assets/images/10.jpg" + ")"}}>    

         <div class="navbar navbar-inverse" role="banner">
            <div class="container" id="containerid">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                        <span class="sr-only">Toggle navigassstion</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>

                    <a class="navbar-brand" href="#/Index1">
                    	<h1 style={{color:'blue',fontFamily:'Biysk-Regular'}}><img src="./assets/images/plogo.png" alt="logo"style={{marginBottom:'17px',width:'26%',fontsize:'52px'}}  />AROPAKARI
                            
                        </h1>
                    </a>
                    
                </div>
                <div class="collapse navbar-collapse">
                      
       <ul className="nav navbar-nav navbar-right">

	   <li id="paro" className="active ">
                   
				   {(() => {if (langID == 'Tamil' ) {return (
						 <li id="paro" className="active tamilbtn "><a className="btn1 third" id="tamilbtn1"  href="#/Login" style={{backgroundColor:'rgb(102, 71, 18)',color:'white',fontWeight: 'bold',padding:'13px',fontSize:16,marginTop:'2px',marginBottom:'-7px',textDecoration:'none',whiteSpace:'nowrap',fontFamily:'cuyabra'}}>
				  
						 {beaparopakari.result}
						 </a></li>
				  );
				  }
				  else if (langID == 'English' ) {return (
					<li id="paro" className="active englishbtn"><a className="btn1 third" href="#/Login" style={{backgroundColor:'rgb(102, 71, 18)',color:'white',fontWeight: 'bold',padding:'13px',fontSize:16,marginTop:'2px',marginBottom:'-7px',textDecoration:'none',whiteSpace:'nowrap',fontFamily:'cuyabra'}}>
				  
					{beaparopakari.result}
					</a></li>
				  );
				  }
				  else if (langID == 'Hindi' ) {return (
					<li id="paro" className="active hindibtn"><a className="btn1 third" href="#/Login" style={{backgroundColor:'rgb(102, 71, 18)',color:'white',fontWeight: 'bold',padding:'13px',textDecoration:'none',whiteSpace:'nowrap',fontFamily:'cuyabra',marginTop:'2px',marginBottom:'-7px'}}>
				  
					{beaparopakari.result}
					</a></li>
				  );
				  }
								   else {return(
				  
									<li id="paro" className="active olangbtn"><a className="btn1 third" id="homepagebutton" href="#/Login" style={{backgroundColor:'rgb(102, 71, 18)',color:'white',fontWeight: 'bold',padding:'13px',fontSize:16,marginTop:'2px',marginBottom:'-7px',textDecoration:'none',whiteSpace:'nowrap',fontFamily:'cuyabra'}}>
				  
							 {beaparopakari.result}
							 </a></li>
				  
				  );}
				  
				  })()}
				  
				  </li>               
      <li>
      {(() => {if (langID == 'Tamil' ) {return (
<a href="#/Ourstory" style={{fontFamily:'cuyabra',fontsize:10,fontWeight: 'bold'}}>{ourstory.result}</a>

);
}
else {return(

<a href="#/Ourstory" style={{fontFamily:'cuyabra',fontWeight: 'bold'}}>{ourstory.result}</a>

);}

})()} 
      
        
        </li> 
  <li>
  {(() => {if (langID == 'Tamil' ) {return (
<a href="#/Howitworks" style={{fontFamily:'cuyabra',fontsize:10,fontWeight: 'bold'}}>{howitworks.result}
    
</a>

);
}
else {return(

<a href="#/Howitworks" style={{fontFamily:'cuyabra',fontWeight: 'bold'}}>{howitworks.result}
    
    </a>

);}

})()} 
    </li> 
  <li>
  {(() => {if (langID == 'Tamil' ) {return (
<a href="#/Blog" style={{fontFamily:'cuyabra',fontWeight: 'bold',fontsize:10}}>{blog.result}</a>

);
}
else {return(

<a href="#/Blog" style={{fontFamily:'cuyabra',fontWeight: 'bold'}}>{blog.result}</a>

);}

})()} 
  
    
    </li>         
                     
  <li>
  {(() => {if (langID == 'Tamil' ) {return (
<a href="#/Login" style={{fontFamily:'cuyabra',fontWeight: 'bold',fontsize:10}}>{login.result}</a>

);
}
else {return(

<a href="#/Login" style={{fontFamily:'cuyabra',fontWeight: 'bold'}}>{login.result}</a>

);}

})()} 

    
    
    </li>                    
</ul>
                </div>
            </div>
        </div>
</header> */}
            {/*/#header*/}

            {/*/#page-breadcrumb*/}
            <section id="about-company" className={this.state.movedown == true ? "wow fadeInUp" : "wow fadeInUp Tiptop"} data-wow-duration="400ms" data-wow-delay="400ms" style={{ backgroundImage: "url(" + "./assets/images/10.jpg" + ")" }}>
              <div className="container" id="containerid">
                <div class="row">
                  <div class="col-lg-12" style={{ color: 'black' }}>
                    <h2><b>{termsandcondition.result}</b></h2>
                    <h6>
                      <small>
                        These Website Standard Terms and Conditions contained herein on this webpage, shall govern your use of this website, including all pages within this website (collectively referred to herein below as this “Website”). These Terms apply in full force and effect to your use of this Website and by using this Website, you expressly accept all terms and conditions contained herein in full. You must not use this Website, if you have any objection to any of these Website Standard Terms And Conditions.<br />
                        KDP Foundation (Paropakari) offers you access to its interactive online websites, applications and services. These Terms of Use, together with our ("Privacy Policy") and any additional terms which might apply to certain products or services, govern your use of our websites ("Website") or any of our mobile widgets or other applications ("Applications") – together, our "Services". Our Services include www.paropakari.com and all other locations on which we place these Terms of Use, as well as all mobile and tablet applications.<br />
                        PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE USING OUR SERVICES. BY USING ANY OF OUR SERVICES (OTHER THAN TO READ THESE TERMS OF USE FOR THE FIRST TIME) YOU ARE AGREEING TO COMPLY WITH THESE TERMS OF USE, WHICH MAY CHANGE FROM TIME TO TIME AS SET FORTH IN SECTION TITLED "AMENDMENTS; ADDITIONAL TERMS". IF YOU DO NOT AGREE TO BE BOUND BY THESE TERMS OF USE, DO NOT USE OUR SERVICES.<br />
                        <br />
                        <b>Legal Status</b><br />
                        KDP Foundation was registered on 10/10/2013.<br />
                        Permanent Account No. (PAN) obtained on 13/12/2013.<br />
                        {/* KDP Foundation was incorporated under the Companies Act, 2013 on 13/05/2015.<br />
					Corporate Identity Number: U74900KA2015PTC080303<br /> */}
                        {/* Permanent Account No. (PAN) obtained on 31/01/2020.<br />
					Tax Deduction Account Number(TAN) obtained on 16/06/2015.<br /> */}
                        <b>Consent to Electronic Disclosures</b><br />
                        Because Paropakari Services are provided electronically, you must consent to Paropakari providing information if you would like to proceed. This notice must be read carefully and a copy may be retained for future reference. Should you consent to receive information electronically the following disclosures will be sent to you via electronic mail or our website:<br />
                        1.    The Paropakari Terms and Conditions, including legal disclosures.<br />
                        2.    Any changes made in the future regarding Paropakari Terms and Conditions.<br />
                        3.    Account information<br />
                        4.    Paropakari  Privacy Policy.<br />
                        5.    All other legal notices and communications and/or disclosures.<br />

                        In order to receive this information through an electronic medium, you must have a computer or mobile smart phone with internet access and the ability to receive e-mail. Please be advised that some web browsers may not be supported.<br />
                        <br />
                        <b>In registering for Paropakari, you:</b><br />
                        1.    Agree to receive information and disclosures electronically on this website and/or via e-mail and confirm that you will download and print any disclosures for your own personal records.<br />
                        2.    Confirm that you have the capacity to receive information that is provided electronically at this website and via e-mail.<br />
                        3.    Authorize electronic delivery of any and all communications and disclosures regarding Paropakari services on this website and via e-mail and providing your consent to receive electronic communications.<br />
                        4. Agree to receive e-mails regarding the Paropakari services.<br />

                        <br />
                        Notices shall be considered as received within 24 hours from the time it has been posted on the website or e-mailed to you unless a notice has been received that the email was not delivered.
                        <br />
                        <b>Paropakari Mobile Applications</b>
                        <br />
                        Paropakari’s mobile application allows users to access many of Paropakari services through a mobile device. If you use the application you are responsible for any fees that your phone service provider charges for SMS, data, etc. Paropakari is not affiliated with any phone service providers.
                        <br />
                        <b>Identity Authentication</b><br />
                        In order to remain compliant with the laws established by the Republic of India, Paropakari reserves the right to obtain, verify and sometimes store personal information. Paropakari is not a Money Services Business; however as required by law Paropakari must store certain pieces of customer information and cooperate with law enforcement to help the government fight terrorism and money laundering. Paropakari may also share this information with some strategic partners.
                        <br />
                        <b>Intellectual Property</b><br />
                        Our Services and associated content (and any derivative works or enhancements of the same) including, but not limited to, all text, illustrations, files, images, software, scripts, graphics, photos, sounds, music, videos, information, content, materials, products, services, URLs, technology, documentation, and interactive features included with or available through our Services (collectively, the "Service Content") and all intellectual property rights to the same are owned by us, our licensors, or both. Additionally, all trademarks, service marks, trade names and trade dress that may appear in our Services are owned by us, our licensors, or identified third parties. Except for the limited use rights granted to you in these Terms of Use, you shall not acquire any right, title or interest in our Services or any Service Content. Any rights not expressly granted in these Terms of Use are expressly reserved. Any event created by a Campaign user, shall be the sole intellectual property of such campaign user with the exception of any trademark, service marks, trade names and trade dress that are the sole intellectual property of the company. Other than content you own, which you may have opted to include on this Website, under these Terms, KDP Foundation (paropakari.com) and/or its licensors own all rights to the intellectual property and material contained in this Website, and all such rights are reserved. You are granted a limited license only, subject to the restrictions provided in these Terms, for purposes of viewing the material contained on this Website.
                        <br />
                        <b>Restrictions</b><br />
                        You are expressly and emphatically restricted from all of the following:<br />
                        1.      publishing any Website material in any media;<br />
                        2.      selling, sublicensing and/or otherwise commercializing any Website material;<br />
                        3.      publicly performing and/or showing any Website material;<br />
                        4.      using this Website in any way that is, or may be, damaging to this Website;<br />
                        5.      using this Website in any way that impacts user access to this Website;<br />
                        6.      using this Website contrary to applicable laws and regulations, or in a way that causes, or may cause, harm to the Website, or to any person or business entity;<br />
                        7.      engaging in any data mining, data harvesting, data extracting or any other similar activity in relation to this Website, or while using this Website;<br />
                        8.      using this Website to engage in any advertising or marketing;
                        Certain areas of this Website are restricted from access by you and KDP Foundation Private Limited (paropakari.com) may further restrict access by you to any areas of this Website, at any time, in its sole and absolute discretion.  Any user ID and password you may have for this Website are confidential and you must maintain confidentiality of such information.

                        <br />
                        <b>Access and Use</b><br />
                        We may offer our Services at no charge. In all instances, our Services are not being sold to you; rather, you are being granted or purchasing a limited license to use our Services. In addition, unless we specifically tell you otherwise, the use of any of our paid Services does not transfer across operating systems and/or different equipment (e.g., mobile devices, computers, etc.).
                        In connection with your use of our website and/or mobile/tablet applications, your account, or the services, or in the course of your interactions with Paropakari, a User or a third party, you will not:
                        <br />
                        In connection with your use of our website and/or mobile/tablet applications, your account, or the services, or in the course of your interactions with Paropakari, a User or a third party, you will not:<br />
                        1.     Violate any law, statute, ordinance, or regulation (for example, those governing financial services, consumer protections, unfair competition, anti-discrimination or false advertising);<br />
                        2.     Act in a manner that is defamatory, trade libelous, unlawfully threatening or unlawfully harassing;<br />
                        3.     Provide false, inaccurate or misleading Information;<br />
                        4.     Send or receive what we reasonably believe to be potentially fraudulent funds;<br />
                        5.     Refuse to cooperate in an investigation or provide confirmation of your identity or any Information you provide to us;<br />
                        6.     Use an anonymous proxy;<br />
                        7.     Control an Account that is linked to another Account that has engaged in any of these Restricted Activities. Conduct your business or use the Services in a manner that results in or may result in complaints, Disputes, Claims, Reversals, Chargebacks, fees, fines, penalties and other liability to Paropakari, a User, a third party or you;<br />
                        8.     Take any action that imposes an unreasonable or disproportionately large load on our infrastructure;<br />
                        9.     Facilitate any viruses, Trojan horses, worms or other computer programming routines that may damage, detrimentally interfere with, surreptitiously intercept or expropriate any system, data or Information;<br />
                        10.  Use any robot, spider, other automatic device, or manual process to monitor or copy our website without our prior written permission;<br />
                        11.  Use any device, software or routine to bypass our robot exclusion headers, or interfere or attempt to interfere, with our website or the Services;<br />
                        12.  Take any action that may cause us to lose any of the services from our internet service providers, payment processors, or other suppliers;<br />
                        13.  Transaction Fee – a fee in connection with certain transactions you may enter using the funds via our Service.<br />
                        <br />
                        When using our Services, you agree to comply with all applicable central, state, and local laws including, without limitation, copyright law. Except as expressly permitted in these Terms of Use or as we may otherwise permit, you may not use, reproduce, duplicate, distribute, create derivative works based upon, publicly display, publicly perform, publish, transmit, or otherwise exploit Service Content for any purpose whatsoever without obtaining prior written consent from us or, in the case third-party content, its applicable owner. In certain instances, we may suggest, ask or otherwise permit you to download, install or print Service Content. In such a case, you may do so only in the manner authorized and for your non-commercial use only. You acknowledge that you do not acquire any ownership rights by downloading, installing or printing Service Content. Furthermore, except as expressly permitted in these Terms of Use, you may not:<br />
                        1.     remove, alter, cover, or distort any copyright, trademark, or other proprietary rights notice we include in or through our Services or Service Content;<br />
                        2.     circumvent, disable or otherwise interfere with our security-related features including, without limitation, any features that prevent or restrict the use of or copying of any software or other Service Content;<br />
                        3.     use an automatic device (such as a robot or spider) or manual process to copy or "scrape" the Website or Service Content for any purpose without our express written permission;<br />
                        4.     collect or harvest any personally identifiable information from our Services including, without limitation, user names, passwords, email addresses;<br />
                        5.     solicit other users to join or become members of any commercial online service or other organization without our prior written approval;<br />
                        6.     attempt to or interfere with the proper working of our Services or impair, overburden, or disable the same;<br />
                        7.     decompile, reverse engineer, or disassemble any portion of our software or other Service Content, or our Services;<br />
                        8.     use network-monitoring software to determine architecture of or extract usage data from our Services;<br />
                        9.     encourage conduct that violates any local, state or federal law, either civil or criminal, or impersonate another user, person, or entity (e.g., using another person’s Membership (as defined below);<br />
                        10.  engage in any conduct that restricts or inhibits any other user from using or enjoying our Services.<br />
                        You agree to fully cooperate with us to investigate any suspected or actual activity that is in breach of these Terms of Use.
                        Paropakari has certain limits in place in order to reduce the risk of fraud and chargebacks within the system. By using Paropakari and its services you agree that you abide by the following parameters:
                        <br />
                        <br />
                        <b>Your Content</b><br />
                        In these Website Standard Terms And Conditions, “Your Content” shall mean any audio, video, text, images or other material you choose to display on this Website. With respect to Your Content, by displaying it, you grant KDP Foundation (paropakari.com) a non-exclusive, worldwide, irrevocable, royalty-free, sublicensable license to use, reproduce, adapt, publish, translate and distribute it in any and all media.
                        <br />Your Content must be your own and must not be infringing on any third party’s rights. KDP Foundation (paropakari.com) reserves the right to remove any of Your Content from this Website at any time, and for any reason, without notice.
                        <br />We permit users to post, create, transmit through, or otherwise make available through our Services (collectively, "submit") messages, text, illustrations, data, files, images, graphics, photos, comments, sounds, music, videos, information, content, and/or other materials ("User Content"). Subject to the rights and license you grant herein, you retain all right, title and interest in your User Content. We do not guarantee any confidentiality with respect to User Content even if it is not published through our Services. It is solely your responsibility to monitor and protect any intellectual property rights that you may have in your User Content, and we do not accept any responsibility for the same.
                        <br />You shall not submit any User Content protected by copyright, trademark, patent, trade secret, moral right, or other intellectual property or proprietary right without the express permission of the owner of the respective right. You are solely liable for any damage resulting from your failure to obtain such permission or from any other harm resulting from User Content that you submit
                        <br />You represent, warrant, and covenant that you will not submit any User Content that:
                        1.     violates or infringes in any way upon the rights of others, including, but not limited to, any copyright, trademark, patent, trade secret, moral right, or other intellectual property or proprietary right of any person or entity;<br />
                        2.     impersonates another or is unlawful, threatening, abusive, libelous, defamatory, invasive of privacy or publicity rights, vulgar, obscene, profane, pornographic, or otherwise objectionable;<br />
                        3.     encourages conduct that would constitute a criminal offense, give rise to civil liability or otherwise violate any law;<br />
                        4.     is an advertisement for goods or services or a solicitation of funds;<br />
                        5.     includes personal information such as messages which identify phone numbers, social security numbers, account numbers, addresses, or employer references;<br />
                        6.     contains a formula, instruction, or advice that could cause harm or injury; or<br />
                        7.     is a chain letter of any kind.<br />
                        <br />
                        Moreover, any conduct by a user that in our sole discretion restricts or inhibits any other user from using or enjoying our Services will not be permitted.
                        By submitting User Content to us, simultaneously with such posting you automatically grant, or warrant that the owner has expressly granted, to us a worldwide, royalty-free, perpetual, irrevocable, non-exclusive, fully sublicensable, and transferable right and license to use, reproduce, distribute, create derivative works based upon (including, without limitation, translations), publicly display, publicly perform, transmit, and publish the User Content (in whole or in part) as we, in our sole discretion, deem appropriate including, without limitation, (1) in connection with our business; and (2) in connection with the businesses of our successors, parents, subsidiaries, and their related companies. We may exercise this grant in any format, media or technology now known or later developed for the full term of any copyright that may exist in such User Content. Furthermore, you also grant other users permission to access your User Content and to use, reproduce, distribute, create derivative works based upon, publicly display, publicly perform, transmit, and publish your User Content for personal, non-commercial use as permitted by the functionality of our Services and these Terms of Use. Notwithstanding the foregoing, you waive any and all claims you may now or later have in any jurisdiction to so-called "moral rights" with respect to the User Content.
                        By submitting User Content, you also grant us the right, but not the obligation to use your biographical information including, without limitation, your name and geographical location in connection with broadcast, print, online, or other use or publication of your User Content; provided, however, that all such uses (including use of data on playlists, genre(s) and other User Content we automatically collect) will be consistent with the terms of our Privacy Policy.
                        We reserve the right to display advertisements in connection with your User Content and to use your User Content for advertising and promotional purposes. You acknowledge and agree that your User Content may be included on the websites and advertising networks of our distribution partners and third-party service providers (including their downstream users).
                        We have the right, but not the obligation, to monitor User Content. We have the right in our sole discretion and for any reason whatsoever to edit, refuse to post, remove, or disable access to any User Content.
                        <br />
                        <br />
                        <b>User Registration</b><br />
                        In order to access or use some features of our Services, you may have to become a registered user<b style={{ color: 'blue' }}> . If you are under the age of 18, then you are not permitted to register as a user or otherwise submit personal information.</b> If you become a registered user, you will provide true, accurate and complete registration information and, if such information changes, you will promptly update the relevant registration information. During registration, you will create a user name and password (a "Membership"). You are responsible for safeguarding and maintaining the confidentiality of your Membership. You are solely responsible for the activity that occurs under your Membership, whether or not you have authorized the activity. You agree to Contact Us immediately if you become aware of any breach of security or unauthorized use of your Membership.
                        <br /><br />
                        <b>Service Content & Third-Party Links</b><br />
                        We provide our Services including, without limitation, Service Content for entertainment and/or promotional purposes only. You may not rely on any information and opinions expressed through any of our Services for any other purpose. In all instances, it is your responsibility to evaluate the accuracy, timeliness, completeness, or usefulness of any Service Content. Under no circumstances will we be liable for any loss or damage caused by your reliance on any Service Content.
                        In many instances, Service Content will include content posted by a third-party or will represent the opinions and judgments of a third-party. We do not endorse, warrant and are not responsible for the accuracy, timeliness, completeness, or reliability of any opinion, advice, or statement offered through our Services by anyone other than our authorized employees or spokespersons while acting in their official capacities.
                        Our Services may link or contain links to other websites maintained by third parties. We do not operate or control, in any respect, or necessarily endorse the content found on these third-party websites. You assume sole responsibility for your use of third-party links. We are not responsible for any content posted on third-party websites or liable to you for any loss or damage of any sort incurred as a result of your dealings with any third-party or their website.
                        <br />
                        <br />
                        <b>Indemnification</b><br />
                        You agree to indemnify and hold harmless KDP Foundation (paropakari.com) and its officers, directors, employees, parents, partners, successors, agents, distribution partners, affiliates, subsidiaries, and their related companies from and against any and all claims, liabilities, losses, damages, obligations, costs and expenses (including reasonable attorneys’ fees and costs) arising out of, related to, or that may arise in connection with: (i) your use of our Services; (ii) User Content provided by you or through use of your Membership; (iii) any actual or alleged violation or breach by you of these Terms of Use; (iv) any actual or alleged breach of any representation, warranty, or covenant that you have made to us; or (v) your acts or omissions. You agree to cooperate fully with us in the defense of any claim that is the subject of your obligations hereunder.<br />
                        <br />
                        <b>Termination</b><br />
                        We reserve the right in our sole discretion and at any time to terminate or suspend your Membership and/or block your use of our Services for any reason including, without limitation if you have failed to comply with the letter and spirit of these Terms of Use. You agree that KDP Foundation Private Limited (paropakari.com) is not liable to you or any third party for any termination or suspension of your Membership or for blocking your use of our Services. Any suspension or termination shall not affect your obligations to us under these Terms of Use. The provisions of these Terms of Use which by their nature should survive the suspension or termination of your Membership or these Terms of Use shall survive including, but not limited to the rights and licenses that you have granted hereunder, indemnities, releases, disclaimers, limitations on liability, provisions related to choose of law, and all of the provisions in the Section titled "MISCELLANEOUS".<br />
                        <br />
                        <b>No warranties</b><br />
                        This Website is provided “as is,” with all faults, and KDP Foundation (paropakari.com) makes no express or implied representations or warranties, of any kind related to this Website or the materials contained on this Website. Additionally, nothing contained on this Website shall be construed as providing consult or advice to you.<br />
                        <br />
                        <b>Limitation of liability</b><br />
                        In no event shall KDP Foundation (paropakari.com), nor any of its officers, directors and employees, be liable to you for anything arising out of or in any way connected with your use of this Website, whether such liability is under contract, tort or otherwise, and KDP Foundation Private Limited (paropakari.com), including its officers, directors and employees shall not be liable for any indirect, consequential or special liability arising out of or in any way related to your use of this Website.

                        <br />
                        <br />
                        <b>Indemnification.</b><br />
                        You hereby indemnify to the fullest extent KDP Foundation (paropakari.com) from and against any and all liabilities, costs, demands, causes of action, damages and expenses (including reasonable attorney’s fees) arising out of or in any way related to your breach of any of the provisions of these Terms.

                        <br />
                        <br />
                        <b>Severability</b><br />
                        If any provision of these Terms is found to be unenforceable or invalid under any applicable law, such unenforceability or invalidity shall not render these Terms unenforceable or invalid as a whole, and such provisions shall be deleted without affecting the remaining provisions herein.<br />
                        <br />
                        <b>Variation of Terms</b>
                        KDP Foundation (paropakari.com) is permitted to revise these Terms at any time as it sees fit, and by using this Website you are expected to review such Terms on a regular basis to ensure you understand all terms and conditions governing use of this Website.<br />
                        <br />
                        <b>Assignment</b><br />
                        KDP Foundation (paropakari.com) shall be permitted to assign, transfer, and subcontract its rights and/or obligations under these Terms without any notification or consent required. However, .you shall not be permitted to assign, transfer, or subcontract any of your rights and/or obligations under these Terms.<br />
                        <br />
                        <b>Entire Agreement</b><br />
                        These Terms, including any legal notices and disclaimers contained on this Website, constitute the entire agreement between KDP Foundation (paropakari.com) and you in relation to your use of this Website, and supersede all prior agreements and understandings with respect to the same.<br />
                        <br />
                        <b>Governing Law & Jurisdiction</b><br />
                        These Terms will be governed by and construed in accordance with the laws of the State of Karnataka , and you submit to the non-exclusive jurisdiction of the state and federal courts located in Karnataka for the resolution of any disputes.<br />
                        <br />
                        <b>Exceptions</b><br />
                        Nothing in this website disclaimer will exclude or limit any warranty implied by law that it would be unlawful to exclude or limit; and nothing in this website disclaimer will exclude or limit KDP Foundation (paropakari.com) liability in respect of any:<br />
                        <br />
                        1. Death or personal injury caused by KDP Foundation (paropakari.com) negligence;<br />
                        2. Fraud or fraudulent misrepresentation on the part of KDP Foundation (paropakari.com) ; or<br />
                        3. Matter which it would be illegal or unlawful for KDP Foundation (paropakari.com) to exclude or limit, or to attempt or purport to exclude or limit, its liability.

                        <br />
                        <br />
                        <b>Reasonableness</b><br />
                        By using this website, you agree that the exclusions and limitations of liability set out in this website disclaimer are reasonable.
                        If you do not think they are reasonable, you must not use this website.
                        <br />
                        <br />
                        <b>Other parties</b><br />
                        You accept that, as a limited liability entity, KDP Foundation (paropakari.com) has an interest in limiting the personal liability of its officers and employees. You agree that you will not bring any claim personally against KDP Foundation Private Limited (paropakari.com) officers or employees in respect of any losses you suffer in connection with the website.
                        Without prejudice to the foregoing paragraph, you agree that the limitations of warranties and liability set out in this website disclaimer will protect KDP Foundation (paropakari.com) officers, employees, agents, subsidiaries, successors, assigns and sub-contractors as well as KDP Foundation (paropakari.com).
                        <br />
                        <br />
                        <b>Amendment; Additional Terms</b><br />
                        We reserve the right in our sole discretion and at any time and for any reason, to modify or discontinue any aspect or feature of our Services or to modify these Terms of Use. In addition, we reserve the right to provide you with operating rules or additional terms that may govern your use of our Services generally, unique of our Services, or both ("Additional Terms"). Any Additional Terms that we may provide to you will be incorporated by reference into these Terms of Use. To the extent any Additional Terms conflict with these Terms of Use, the Additional Terms will control.
                        Modifications to these Terms of Use or Additional Terms will be effective immediately upon notice, either by posting on the Website, notification by email or through any of our Applications. It is your responsibility to review the Terms of Use from time to time for any changes or Additional Terms. Your access and use of our Services following any modification of these Terms of Use or the provision of Additional Terms will signify your assent to and acceptance of the same. If you object to any subsequent revision to the Terms of Use or to any Additional Terms, immediately discontinue use of our Services and, if applicable, terminate your Membership.
                        <br />
                        <br />
                        <b>Miscellaneous</b><br />
                        No waiver by either party of any breach or default hereunder shall be deemed to be a waiver of any preceding or subsequent breach or default. The section headings used herein are for convenience only and shall not be given any legal import.<br />
                        Except where specifically stated otherwise, if any part of these Terms of Use is unlawful or unenforceable for any reason, we both agree that only that part of the Terms of Use shall be stricken and that the remaining terms in the Terms of Use shall not be affected.<br />
                        These Terms of Use (including the Privacy Policy and any Additional Terms incorporated by reference) constitute the entire agreement of the parties with respect to the subject matter hereof and supersede all previous written or oral agreements between us with respect to such subject matter.<br />
                        You may not assign these Terms of Use or assign any rights or delegate any obligations hereunder, in whole or in part, without our prior written consent. Any such purported assignment or delegation by you without the appropriate prior written consent will be null and void and of no force and effect. We may assign these Terms of Use or any rights hereunder without your consent and without notice.<br />
                        <br />
                        This website uses cookies. By using this website and agreeing to these terms and conditions, you consent to our KDP Foundation (paropakari.com)'s use of cookies in accordance with the terms of KDP Foundation (paropakari.com)'s privacy policy/cookies policy.<br />

                        <hr />
                        <h5><b>Cancellation and Refund Policy</b></h5>
                        We cherish every donation and work hard to ensure every rupee is put to work helping others quickly. When we receive your donation, we believe it was your full intention to support our efforts and our initiatives. Because of this, all donations made through Paropakari.com platform cannot be refunded. <br />
                        We may offer refunds of received donations in exceptional circumstances, such as:<br /><br />
                        •	Fraudulent campaigns, where funds have not been transferred to the beneficiaries<br />
                        •	Illegal donations<br />
                        •	Fundraising campaign has been cancelled <br />
                        •	Any other scenario determined as refundable by Paropakari <br />
                        All requests for refunds in exceptional circumstances must be made within 7 days of making a donation. If requests are made after this duration, they will not be entertained.<br />
                        The refund process may take time 7 to 30 working days depending on the availability of the information from third parties such as Payment Gateway, Banks, etc. through which transaction is done.<br />



                      </small>
                    </h6>
                    <hr />
                    <h5>Copyright</h5>
                    <h6>
                      <small>
                        This website and its content is copyright of KDP Foundation © 2018. All rights reserved.<br />
                        Any redistribution or reproduction of part or all of the contents in any form is prohibited other than the following:<br />
                        1. You may print or download to a local hard disk extracts for your personal and non-commercial use only<br />
                        2. You may copy the content to individual third parties for their personal use, but only if you acknowledge the website as the source of the material<br />
                        You may not, except with our express written permission, distribute or commercially exploit the content. Nor may you transmit it or store it in any other website or other form of electronic retrieval system.
                      </small>
                    </h6>
                    <hr />

                  </div>
                </div>
              </div>
            </section>

            {/*/#team*/}
            <footer id="footer" style={{ color: 'white' }}>
              <br />
              <div className="container">
                <div className="copyright">

                  <div className="row col-lg-12">

                    <div className="col-lg-9 mb-6">
                      {/* {foo.map((fo) => (
          <p className="m-0 text-center text-black" style={{paddingTop: '-50px', fontSize: 12,color:'white'}}>
     <a className="blink_me" style={{color: '#ffd9a2', fontSize: 18}}> &nbsp;{fo.posts}</a>&nbsp;Causes 
      <a className="blink_me" style={{color: '#ffd9a2', fontSize: 18}}>&nbsp;{fo.beneficiaries}</a>&nbsp;Beneficiaries
       <a className="blink_me" style={{color: '#ffd9a2', fontSize: 18}}> &nbsp;{fo.paropakaris}</a>&nbsp;Paropakaris
       <a className="blink_me" style={{color: '#ffd9a2', fontSize: 18}}> &nbsp;{fo.raisedAmount}</a>&nbsp;Amount Raised
       </p>
       ))} */}


                      <p >{copyright_new.result} &nbsp;{currentYear} © {paropakari_new.result} |&nbsp;<a href="#/Contactus" style={{ textDecoration: 'none', color: 'white' }}>{contactus.result}&nbsp;</a>| <a href="#/PrivacyPolicy" style={{ textDecoration: 'none', color: 'white' }}>&nbsp;{privacypolicy.result}&nbsp;</a>|<a href="#/TermsandCondition" style={{ textDecoration: 'none', color: 'white' }}>&nbsp;{termsandcondition.result}</a></p>

                    </div>
                    <div className="col-lg-3 mb-3">

                      <div className="social-icons" style={{ color: 'white' }}>
                        <ul className="nav nav-pills">
                          <li><a target="_blank" href="https://www.facebook.com/beoneparopakari"><i className="fa fa-facebook" /></a></li>
                          {/* <li><a target="_blank"  href="https://twitter.com/login?lang=en" ><i className="fa fa-twitter" /></a></li> */}
                          <li><a target="_blank" href="https://www.youtube.com/channel/UCP9oeqbf4lCy3io7uy1-NQw" ><i className="fa fa-youtube-play" /></a></li>
                          <li><a target="_blank" href="https://www.instagram.com/paropakari_beone/" ><i className="fa fa-instagram" /></a></li>
                          <li><a target="_blank" href="https://www.linkedin.com/company/paropakari/"><i className="fa fa-linkedin" /></a></li>
                        </ul>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div className="containerss">

              </div>
            </footer>

            {/*/#footer*/}
          </div>

        </div>
      </div>
    )
  }
}